export default "__VITE_ASSET__C7bY7K$E__"